import * as fromEvents from './events.reducer';
import * as fromFeatured from './featured-events.reducer';
import * as fromRelated from './related-events.reducer';
import * as fromFilterFields from './filter-fields.reducer';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'event';

export interface EventState {
  events: fromEvents.EventsState;
  featuredEvents: fromFeatured.FeaturedEventsState;
  relatedEvents: fromRelated.RelatedEventsState;
  filterFields: fromFilterFields.FilterFieldsState;
}

export const reducers: ActionReducerMap<EventState> = {
  events: fromEvents.EventsReducer,
  featuredEvents: fromFeatured.FeaturedEventsReducer,
  relatedEvents: fromRelated.RelatedEventsReducer,
  filterFields: fromFilterFields.filterFieldsReducer,
};

export const getEventState = createFeatureSelector<EventState>(featureKey);

export const metaReducers: MetaReducer<EventState>[] = !environment.production ? [] : [];
